import { create } from 'zustand';

const initialSlice = (set, get) => ({
    search: null,
    sort: null,

    setSearch: (value) => set({ search: value }),
    setSort: (value) => set({ sort: value }),
    resetFilter: () => set({ search: null, sort: null }),
});

export const useFilterPBundle = create((set, get) => ({
    ...initialSlice(set, get),
}));

export const useFilterPSatuan = create((set, get) => ({
    ...initialSlice(set, get),
}));
